export * from './mercurygate-adds-linescape-to-tms';


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/press/mercurygate-adds-linescape-to-tms/index.ts